export default __webpack_public_path__ + "static/media/Amanita39.3ee8081f.jpg";